<template>
    <div class="bg-a-egg-f5ebdc min-h-screen">
        <div class="topbar-height shadow-md fixed top-0 w-full left-0 bg-a-egg-f5ebdc">
            <div class="relative max-full-hd h-full flex">
                <div class="absolute left-4 h-full flex"><img class="my-auto" @click="gotoHome()" src="@/assets/icon/ic-close-brown.svg" /></div>
                <div class="m-auto"><img class="logo-bk" src="@/assets/header/logo-bk.svg"/></div>
                <div class="absolute top-0 right-4 h-full flex">
                    <SwitchLanguageBtn></SwitchLanguageBtn>
                </div>
            </div>
        </div>
        <div class="padding-topbar">
            <div class="max-full-hd" v-if="dashboardList.length > 0"><img class="w-full cursor-pointer" @click="clickDashboard(dashboardList[0])" :src="dashboardList[0].imageUrl" /></div>
            <div class="max-w-1140px mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 p-6 md:py-8">
                <div v-for="(dashboard, k) in dashboardList.filter((item, index) => index > 0)"
                    :key="k">
                    <img class="w-full cursor-pointer"  @click="clickDashboard(dashboard)" :src="dashboard.imageUrl" />
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
//config
import CacheHelper from '@/helper/CacheHelper'
import { CacheKey } from '@/helper/StaticValue'
//comoponent
import SwitchLanguageBtn from '@/components/Button/SwitchLanguageBtn.vue';
//Mixin
import DeliveryMixin from '@/mixin/DeliveryMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";
export default {
    name: "Navigate",
    mixins: [DeliveryMixin,LocaleMixin],
    components: {
        SwitchLanguageBtn,
    },
    data: function () {
        return {
            dashboardList: [],
        };
    },
    created: function () {
        this.tracking.screenName('landing');
        this.tracking.event('landing','view_landingpage', null, null);
        this.getDashboard();
    },
    methods: {
        getDashboard: function() {
            var configBuilder = new SubDashboardConfigBuilder();
            var params = configBuilder.create().getParams();
   
            BzbsDashboard.apiGetSubDashboard(params, 'burgerking_landing_page_web').subscribe((data) => {
                if (data.length > 0) {
                    this.dashboardList = data;   
                    console.log(this.dashboardList);
                }
            }, (err) => {
                console.log(err);
            });
        },
        clickDashboard: function(dashboard) {
            if (dashboard.type == 'link') { 
                if (dashboard.url == 'deliverymethod') {
                    this.tracking.event('landing','click_delivery', null, null);
                    this.orderNow('Delivery')
                } else if (dashboard.url == 'selectbranch') {
                    this.tracking.event('landing','click_selfpickup', null, null);
                    this.orderNow('InStore')
                } else if (dashboard.url == 'earnpoint') {
                    this.tracking.event('landing','click_earnpoint', null, null);
                    this.$router.push('/' + dashboard.url);
                } else if (dashboard.url == 'reward') {
                    this.tracking.event('landing','click_earnpoint', null, null);
                    this.$router.push('/' + dashboard.url);
                } else {
                    if (dashboard.url.includes('http')) {
                        window.open(dashboard.url, '_blank');
                    } else {
                        this.$router.push('/' + dashboard.url);
                    }
                }
            } else if (dashboard.type == 'campaign') {
                this.$router.push('/product/' + dashboard.id);
            } else if (dashboard.type == 'bzbs_cat' || dashboard.type == 'cat') {
                if (dashboard.cat == "rewards") {
                    this.tracking.event('landing','click_rewards', null, null);
                    this.$router.push('/reward');
                } else {
                    this.$router.push('/home/' + dashboard.cat);
                }
            }
        },
        orderNow: function(deliveryMethod) {
            this.delivery.deliveryMethod = deliveryMethod;
            this.updateIsFromDeliveryMethod(true);
            let cache = new CacheHelper('session');
            cache.setCache(CacheKey.nav, { isFromNav: true });
            this.$router.replace('/deliverymethod');
        },
        gotoHome: function() {
            this.tracking.event('landing','click_close_landingpage', null, null);
            this.$router.replace("/home");
        },
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import '@/style/base/display.scss';
    @import "@/style/base/image.scss";
    .topbar-height {
        height: $topbar-height;
    }

    .padding-topbar {
        padding-top: $topbar-height;
    }
    .logo-bk {
        height: $bk-logo-height;
    }

    .bg-image {
        @include boxRatio($ratio: 33.33%);
    }
</style>
